
export const HotelSearchQueryParamsSlitter = '|';
export const HotelSearchQueryParamsRoomSlitter = '@';

export enum HotelSearchQueryParams {
  Location = 'l',
  Rooms = 'r',
  from = 'f',
  to = 't',
  Property = 'propertyId'
}
